import { Divider, Stack, Text } from '@mantine/core';

import { CollapsableProject } from '@/module/AnnualReport/items/collapsable/CollapsableProject';
import { AnnualReportProjects } from '@/module/AnnualReport/model/AnnualReportTypes';

interface AnnualProjectsOverviewProps {
  projects: AnnualReportProjects;
  year: number;
}

export function AnnualProjectsOverview({ projects, year }: AnnualProjectsOverviewProps) {
  return (
    <Stack gap="xl">
      <Text
        mt="10px"
        fs="xl"
        fw="500"
      >
        Proiecte DEPUSE în anul {year} (dar necâştigătoare sau cu rezultat încă neanunţat)
      </Text>
      <CollapsableProject
        title="Proiecte depuse în competiții internaționale (în care universitatea este coordonator)"
        projects={projects.internatCoordSubmittedProjects}
      />
      <CollapsableProject
        title="Proiecte depuse în competiții internaționale (în care universitatea este partener)"
        projects={projects.internatPartSubmittedProjects}
      />
      <CollapsableProject
        title="Proiecte depuse în competiții naționale (în care universitatea este coordonator)"
        projects={projects.natCoordSubmittedProjects}
      />
      <CollapsableProject
        title="Proiecte depuse în competiții naționale (în care universitatea este partener)"
        projects={projects.natPartSubmittedProjects}
      />
      <CollapsableProject
        title="Proiecte depuse în competiții locale (granturile interne de cercetare – individuale și de tip colective de cercetare - finanțate de către UMFST G.E. Palade Tg. Mureș, cu sau fără participare privată)"
        projects={projects.localGrantSubmittedProjects}
      />
      <CollapsableProject
        title="Proiecte depuse în competiție locală cu finanțare privată (granturile interne de cercetare cu finanțare privată desfășurate prin UMFST G.E. Palade Tg. Mureș)"
        projects={projects.localPrivateSubmittedProjects}
      />
      <Divider />
      <Text
        mt="10px"
        fs="xl"
        fw="500"
      >
        Proiecte CÂȘTIGATE în anul {year}
      </Text>
      <CollapsableProject
        title="Proiecte câștigate în competiții internaționale (în care universitatea este coordonator)"
        projects={projects.internatCoordWonProjects}
      />
      <CollapsableProject
        title="Proiecte câștigate în competiții internaționale (în care universitatea este partener)"
        projects={projects.internatPartWonProjects}
      />
      <CollapsableProject
        title="Proiecte câștigate în competiții naționale (în care universitatea este coordonator)"
        projects={projects.natCoordWonProjects}
      />
      <CollapsableProject
        title="Proiecte câștigate în competiții naționale (în care universitatea este partener)"
        projects={projects.natPartWonProjects}
      />
      <CollapsableProject
        title=" Proiecte câștigate în competiție locală (granturile interne de cercetare – individuale și de tip colective de cercetare - finanțate de către UMFST G.E. Palade Tg. Mureș, cu sau fără participare privată)"
        projects={projects.localGrantWonProjects}
      />
      <CollapsableProject
        title="Proiecte câștigate în competiție locală cu finanțare privată (granturile interne de cercetare cu finanțare privată desfășurate prin UMFST G.E. Palade Tg. Mureș)"
        projects={projects.localPrivateWonProjects}
      />
      <Divider />
      <Text
        mt="10px"
        fs="xl"
        fw="500"
      >
        Proiecte ÎN DERULARE în anul {year}, dar câștigate anterior anului {year}
      </Text>
      <CollapsableProject
        title={`Proiecte derulate în anul ${year}, câștigate prin competiții internaționale anterioare anului ${year} (în care universitatea este coordonator)`}
        projects={projects.internatCoordWonOngoingProjects}
      />
      <CollapsableProject
        title={`Proiecte derulate în anul ${year}, câștigate prin competiții internaționale anterioare anului ${year} (în care universitatea este partener)`}
        projects={projects.internatPartWonOngoingProjects}
      />
      <CollapsableProject
        title={`Proiecte derulate în anul ${year} câștigate prin competiții naţionale anterioare anului ${year} (în care universitatea este coordonator)`}
        projects={projects.natCoordWonOngoingProjects}
      />
      <CollapsableProject
        title={`Proiecte derulate în anul ${year}, câștigate prin competiții naționale anterioare anului ${year} (în care universitatea este partener)`}
        projects={projects.natPartWonOngoingProjects}
      />
      <CollapsableProject
        title={`Proiecte derulate în anul ${year} câștigate în competiție locală anterioară anului ${year} (granturile interne de cercetare de tip colective de cercetare - finanțate de către UMFST G.E. Palade Tg. Mureș cu participare privată)`}
        projects={projects.localGrantWonOngoingProjects}
      />
    </Stack>
  );
}
